export default __webpack_public_path__ + "static/shelter-edd6ca5e3afce7ea3ae234b9f6d88ff0.png";